import React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import History from "../../utilities/History";
import { v4 as uuidv4 } from "uuid";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import {
  MODULE_GRADE,
  EDIT,
  CREATE,
  GRADE_INDEX_URL,
  CHANGE_EVENT,
  MODULE_PROPERTY,
  ASSOCIATE,
  GRADE_ASSOCIATE_PROPERTY_URL,
  GRADE_CREATE_URL,
  NOTIFICATION_TIMEOUT,
  STEP1,
  ASSIGN_THRESHOLD_VALUES,
  FORMULA_DEFINITION,
  STEP2,
  NAME_VALIDATION_ERROR,
} from "../../utilities/Constants";
import { IGradeFormData } from "../../models/grade/GradeFormData";
import { ABB_EDIT, ABB_PLUS } from "../../utilities/IconConstants";
import SubmitHeader from "../shared/SubmitHeader";
import IFormComponent from "../../models/shared/FormComponent";
import {
  Input,
  Dropdown,
  DropdownOption,
  Button,
  Dialog,
  RadioGroup,
  RadioOption,
  TabControl,
  TabItem,
  Icon,
} from "@abb/abb-common-ux-react";
import { ITestplanViewData } from "../../models/testplan/TestplanViewData";
import testplanActions from "../../flux/actions/TestplanActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import testplanListStore from "../../flux/stores/testplan/ListStore";
import testplanByIdStore from "../../flux/stores/testplan/ByIdStore";
import TableComponent from "../shared/TableComponent";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import tableFormatter from "../shared/TableFormatter";
import instrumentActions from "../../flux/actions/InstrumentActions";
import instrumentSelectedIdStore from "../../flux/stores/instrument/BySelectedIdStore";
import { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";
import {
  IPropertySpecification,
  PropertySpecification,
} from "../../models/shared/PropertySpecification";
import { IKeyedInProperty } from "../../models/testplan/TestplanKeyedIn";
import propertyActions from "../../flux/actions/PropertyActions";
import { IPropertyViewData } from "../../models/property/PropertyViewData";
import propertySelectedIdStore from "../../flux/stores/property/BySelectedIdStore";
import { IInstrumentProperty } from "../../models/instrument/InstrumentPropertyData";
import gradeActions from "../../flux/actions/GradeActions";
import gradeFormStore from "../../flux/stores/grade/FormStore";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import { TestplanBasicData } from "../../models/testplan/TestplanBasicData";
import AbbTableComponent from "../shared/AbbTableComponent";
import AssociateCalculatedProperty from "./AssociateCalculatedProperty";
import propertySelectedCalculatedIdStore from "../../flux/stores/property/BySelectedCalculatedIdStore";
import calculatedPropertyActions from "../../flux/actions/CalculatedPropertyActions";
import {
  ICalculatedPropertyViewData,
  IVariableData,
  IAttributeData,
  IPropertyData,
} from "../../models/property/CalculatedPropertyViewData";
import IReading from "../../models/property/ReadingData";
import calculatedPropertySourceListStore from "../../flux/stores/calculatedProperty/ListStoreSource";
import calculatedPropertyValuesListStore from "../../flux/stores/calculatedProperty/ListStoreValues";
import calculatedPropertyDetailsIdStore from "../../flux/stores/calculatedProperty/BySelectedIdStore";
import GradeCalculatedData, {
  IGradeCalculatedData,
} from "../../models/grade/GradeCalculatedData";
import CalculatedPropertyViewData from "../../models/property/CalculatedPropertyViewData";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import partitionsDetailsListStore from "../../flux/stores/calculatedProperty/ListStorePartitions";
import _ from "lodash";
import productActions from "../../flux/actions/ProductActions";
import { ProductFormData } from "../../models/product/ProductFormData";
import { GradeBasicData } from "../../models/grade/GradeBasicData";
import i18next from "i18next";
import CalculatedProperty from "../../components/sharedNew/CalculatedProperty";
import PropertySteps from "../../components/sharedNew/PropertySteps";
import PropertyTable from "../../components/sharedNew/PropertyTable";
import FormulaDefinitionTable from "../../components/sharedNew/FormulaDefinitionTable";
import gradeListStore from "../../flux/stores/grade/ListStore";
import IdGenerator from "../../utilities/GenerateId";
import { IGradeViewData } from "../../models/grade/GradeViewData";

type PropsType = RouteComponentProps & {
  location: any;
};

interface IFormState {
  gradeFormData: IGradeFormData;
  testPlanDropdownList: any[];
  instrumentDropdownList: any[];
  calculatedDropdownList: any[];
  allCalculatedDropdownList: any[];
  selectedCalculatedProperties: any[];
  calculatedPropertyDetails: ICalculatedPropertyViewData[];
  readingSourceList: any[];
  readingValuesList: any[];
  modalWarningTestplanChange: boolean;
  value: string;
  showthreshold: boolean;
  showformula: boolean;
  isNext: boolean;
  isStep: boolean;
  disableValueDropdown: boolean;
  disablePositionDropdown: boolean;
  disableSourceDropdown: boolean;
  oldData: IGradeFormData;
  valueList: any[];
  formLoading: boolean;
  isLoading: boolean;
  nameError: boolean;
  codeError: boolean;
  orderProperties: any[];
  fetchedCalculatedProperties: any;
}

class Form
  extends React.Component<PropsType, IFormState>
  implements IFormComponent {
  private _mount: boolean = false;
  private _isReload: boolean;
  private _messages: string[];
  private _id: string;
  private _testplanDropdownList: ITestplanViewData[] = [];
  private _selectedTestplan: ITestplanViewData;
  private _calculatedDropdownList: IPropertyViewData[] = [];
  private _selectedCalculated: IPropertyViewData;
  private _tempTestplan: any[] = [];
  private _columns: IColumnHeaderData[];
  private _fetchedInstruments: IInstrumentViewData[] = [];
  private _fetchedProperties: IPropertyViewData[] = [];
  private _fetchedCalculatedProperties: IPropertyViewData[] = [];
  private _calculatedPropertyDetails: ICalculatedPropertyViewData[] = [];
  private _readingSourceDropdown: IReading[] = [];
  private _readingValuesDropdown: IReading[] = [];
  private _readingSourceList: any[] = [];
  private _readingValuesList: any[] = [];
  private _partitionName: any[] = [];
  private _oldPartitionName: any[] = [];
  private _partitionListData: any;
  private _indexSourceCount: number;
  private _indexValueCount: number;
  private _indexPartitionCount: number;
  private _testplanproperties: IPropertySpecification[] = [];
  private optionRef = React.createRef();
  private _listData: any[];

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state.gradeFormData
      ? this.props.location.state.gradeFormData
      : (this.props.location.state as IGradeFormData);
    this.state = {
      gradeFormData: pushStateData.previousState
        ? pushStateData.previousState
        : pushStateData,
      testPlanDropdownList: [],
      instrumentDropdownList: [],
      calculatedDropdownList: [],
      allCalculatedDropdownList: this.props.location.state
        ?.allCalculatedDropdownList?.length
        ? this.props.location.state?.allCalculatedDropdownList
        : [],
      selectedCalculatedProperties: this.props.location.state
        ?.selectedCalculatedProperty?.length
        ? this.props.location.state?.selectedCalculatedProperty.map(
          (item: any) => ({
            value: item?.propertyId,
            label: item?.propertyName,
          })
        )
        : [],
      calculatedPropertyDetails: [],
      fetchedCalculatedProperties: this.props.location.state?.fetchedCalculatedProperties ?
        this.props.location.state?.fetchedCalculatedProperties : [],
      readingSourceList: [],
      readingValuesList: [],
      modalWarningTestplanChange: false,
      value: "",
      showthreshold: true,
      showformula: false,
      isNext: false,
      isStep: false,
      disableValueDropdown: false,
      disablePositionDropdown: true,
      disableSourceDropdown: false,
      oldData: { ...pushStateData },
      valueList: [],
      formLoading: false,
      isLoading: false,
      nameError: false,
      codeError: false,
      orderProperties: [],
    };
  }

  public filterProperties = (allProps: any, props: any) => {
    const allPropertiesIds = new Set(allProps.map((prop: any) => prop.propertyId));
    return props.filter((prop: any) => allPropertiesIds.has(prop.propertyId));
  };

  componentDidMount() {
    this._mount = true;
    this.getAllCalculatedPropertiesEdit();
    this.validate();
    if (this._mount) {
      document.addEventListener("mousedown", this.onCloseAll);
    }
    if (!this.state.gradeFormData?.isEditMode) {
      const stateData: any = this.props.history.location.state;
      if (stateData?.testplan?.id !== "") {
        const calculatedIds: string[] = [];
        this.state.gradeFormData.properties.map((id, index) => {
          calculatedIds.push(id.propertyId);
        });

        propertyActions.getSelectedCalculated(calculatedIds).then(() => {
          const calculatedDropdownList: any[] = [];
          this._fetchedCalculatedProperties.forEach(
            (element: IPropertyViewData) => {
              calculatedDropdownList.push({
                value: element.id,
                label: element.name,
              });
            }
          );

          const properties = this.state.gradeFormData.properties;
          const isCalculated = this.state.gradeFormData.properties.filter(
            (x) => x.isCalculated
          );
          if (isCalculated.length) {
            let arrItem: any[] = [];
            isCalculated.forEach((item: any) => {
              const value: any = {
                isNew: false,
                itemTemplate: undefined,
                label: item.propertyName,
                menuItemTemplate: undefined,
                selectedItemTemplate: undefined,
                value: item.propertyId,
              };
              arrItem.push(value);
            });
            this.setCalculatedPropertyDetails(arrItem);
          }

          this.setState(
            {
              gradeFormData: {
                ...this.state.gradeFormData,
                properties,
              },
              isNext: isCalculated.length ? true : false,
              calculatedDropdownList,
            },
            () => {
              this._testplanproperties = this.state.gradeFormData.allProperties;
            }
          );
        });
      }
      // gradeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      //   if (this._mount) {
      //     this._listData = state.gradeDataList.result as IGradeViewData[];
      //     const copyCode: any = this.props.history.location.state
      //     const code = this._listData[0].code;
      //     const id = IdGenerator.incrementId(code);
      //     const idString = copyCode.code === "" ? id.toString() : copyCode.code;

      //     this.setState({
      //       gradeFormData: {
      //         ...this.state.gradeFormData,
      //         code: idString
      //       }
      //     });
      //   }
      // });

      // gradeActions
      // .getAll(
      //   false,
      //   1,
      //   CONSTANTS.PAGE_SIZE,
      //   CONSTANTS.SORT_CREATEDON,
      //   CONSTANTS.SORT_ORDER,
      //   ""
      // )
      // .then();
    }

    if (this.state.gradeFormData?.isEditMode) {
      const selectedCalculated: any[] = [];
      let calculatedPropertyDetails: ICalculatedPropertyViewData[] = [];
      let properties: IPropertySpecification[] = [];

      let isNext: boolean = false;
      if (this.state.gradeFormData?.selectedCalculatedProperty?.length > 0) {
        this.state.gradeFormData?.selectedCalculatedProperty.map((data: any) => {
          const value = {
            label:
              data.property === undefined
                ? data.propertyName
                : data.property.name,
            value:
              data.property == undefined ? data.propertyId : data.property.id,
          };

          if (data?.formulaMappings !== undefined) {
            let selectedSource: any[] = [];
            let selectedValue: any[] = [];
            let selectedPosition: string;
            let disablePosition = false;
            let disableValue = false;
            let disableSource = false;
            let id = "";
            let variable = "";
            let attribute: IAttributeData = { id: "", name: "" };
            let property: IPropertyData = {
              id: "",
              name: "",
              customId: "",
            };
            const variableMapData: IVariableData[] = [];
            data.formulaMappings[0]?.variableMapping.map(
              (variables: any, i: number) => {
                let randomNumber = Math.random();
                if (
                  variables.variableMapping?.source !== null &&
                  variables.variableMapping?.value !== null
                ) {
                  if (variables?.attribute?.name !== "Measured Property") {
                    disablePosition = true;
                    disableValue = true;
                    disableSource = true;
                  }
                  if (
                    variables.variableMapping?.source?.name === "Individual"
                  ) {
                    disablePosition = true;
                    disableValue = true;
                    selectedSource =
                      variables.variableMapping?.source !== null
                        ? [
                          {
                            label: variables?.variableMapping?.source?.name,
                            value: variables?.variableMapping?.source?.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables?.variableMapping?.value !== null
                        ? [
                          {
                            label: variables.variableMapping?.value?.name,
                            value: variables.variableMapping?.value?.id,
                          },
                        ]
                        : [];
                  } else if (
                    variables.variableMapping?.source?.name === "Position"
                  ) {
                    const testplanId = this.state.gradeFormData?.testplan?.id;
                    const calculatedId = data.property?.id;
                    const propertyId = variables.property.id;
                    calculatedPropertyActions
                      .getPartitions(calculatedId, propertyId, testplanId)
                      .then(() => {
                        if (this._partitionName.length > 0) {
                          this._oldPartitionName = this._partitionName;
                        }
                        this._partitionListData.partitions.map(
                          (partitionName: any) => {
                            this._partitionName.push({
                              label: partitionName.name,
                              value:
                                partitionName.position + `(${randomNumber})`,
                            });
                          }
                        );
                        this.setState({}, () => this.forceUpdate());
                      })
                      .catch((error) => {
                        triggerNotifications
                          .errors(error.message, error.data)
                          .then();
                      });

                    disablePosition = false;
                    disableValue = false;
                    selectedSource =
                      variables.variableMapping?.source !== null
                        ? [
                          {
                            label: variables.variableMapping?.source.name,
                            value: variables.variableMapping?.source.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables.variableMapping?.value !== null
                        ? [
                          {
                            label: variables.variableMapping?.value.name,
                            value: variables.variableMapping?.value.id,
                          },
                        ]
                        : [];
                    selectedPosition =
                      variables.variableMapping.position !== null
                        ? variables.variableMapping.position +
                        `(${randomNumber})`
                        : "";
                  } else {
                    disablePosition = true;
                    disableValue = false;
                    selectedSource =
                      variables.variableMapping?.source !== null
                        ? [
                          {
                            label: variables.variableMapping?.source.name,
                            value: variables.variableMapping?.source.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables.variableMapping?.value !== null
                        ? [
                          {
                            label: variables.variableMapping?.value.name,
                            value: variables.variableMapping?.value.id,
                          },
                        ]
                        : [];
                  }
                } else {
                  disablePosition = true;
                  disableValue = true;
                  disableSource = true;
                  selectedSource = [];
                  selectedValue = [];
                  selectedPosition = "";
                }
                id = variables.id;
                variable = variables.variable;
                attribute = variables.attribute;
                property = variables.property;
                const varData = {
                  id,
                  variable,
                  attribute,
                  property,
                  selectedSource,
                  selectedValue,
                  selectedPosition,
                  disablePosition,
                  disableValue,
                  disableSource,
                };
                variableMapData.push(varData);
                selectedSource = [];
                selectedValue = [];
                selectedPosition = "";
              }
            );

            const calculatedPropertyDetailData = new CalculatedPropertyViewData(
              data.property?.id,
              data.property?.name,
              String(data.formulaMappings[0].formula),
              variableMapData
            );

            calculatedPropertyDetails.push(calculatedPropertyDetailData);
          }

          selectedCalculated.push(value);

          const property = this.state.gradeFormData.properties.find(
            (x) => x.propertyId === data.property?.id
          );
          const propertyIndex = this.state.gradeFormData.properties.findIndex(
            (x) => x.propertyId === data.property?.id
          );

          if (property !== undefined) {
            if (data.formulaMappings !== undefined) {
              data?.formulaMappings[0]?.variableMapping.map((variables: any) => {
                const sourceId =
                  variables.variableMapping?.source === null
                    ? ""
                    : variables.variableMapping?.source?.id;
                const position =
                  variables.variableMapping?.position === null
                    ? ""
                    : variables.variableMapping?.position;
                const valueId =
                  variables.variableMapping?.value === null
                    ? ""
                    : variables.variableMapping?.value.id;
                const sourceMappingData = {
                  sourceId,
                  position,
                  valueId,
                  propertyAttributeId: variables?.attribute.id,
                  propertyId: variables.property.id,
                  variable: variables.variable,
                };
                this.state.gradeFormData.properties[
                  propertyIndex
                ].sourceMappings.push(sourceMappingData);
              });
            }
            properties = this.state.gradeFormData.allProperties.length
              ? this.state.gradeFormData.allProperties
              : this.state.gradeFormData.properties;
          }
          properties = this.state.gradeFormData.properties;
          isNext = true;
        });
      } else {
        properties = this.state.gradeFormData.allProperties.length
          ? this.state.gradeFormData.allProperties
          : this.state.gradeFormData.properties;
        isNext = false;
      }
      this._testplanproperties = this.filterProperties(this.state.gradeFormData.allProperties, this.state.gradeFormData.properties).filter(
        (x:any) => x.isCalculated !== true
      );

      const selectedCalculatedProperties: any[] = [];
      if (this.state.gradeFormData.selectedCalculatedProperty.length) {
        this.state.gradeFormData.selectedCalculatedProperty.map((item: any) => {
          if (item.propertyId) {
            // property specification
            selectedCalculatedProperties.push({
              label: item.propertyName,
              value: item.propertyId,
            });
          } else {
            // calculated specification
            selectedCalculatedProperties.push({
              label: item.property.name,
              value: item.property.id,
            });
          }
        });
      }

      calculatedPropertyDetails.forEach((el) => {
        if (
          el.variables.find(
            (ele) => ele.attribute?.name === "Measured Property"
          )
        ) {
          this._indexValueCount = calculatedPropertyDetails.length;
        }
      });

      this.setState(
        {
          isNext,
          calculatedPropertyDetails,
          selectedCalculatedProperties,
        },
        () => {
        }
      );
    }

    navigationHeaderActions
      .updateHeader({
        name: MODULE_GRADE,
        action: this.state.gradeFormData.isEditMode ? EDIT : CREATE,
        icon: this.state.gradeFormData.isEditMode ? ABB_EDIT : ABB_PLUS,
        goBackUrl: GRADE_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    testplanByIdStore.on(CHANGE_EVENT, (state) => {
      this._selectedTestplan = state.testplanData;
      this.setState({
        gradeFormData: {
          ...this.state.gradeFormData,
          calculatedPropertyDetails: state.testplanData
        }
      })
    });

    testplanListStore.on(CHANGE_EVENT, (state) => {
      this._testplanDropdownList = state.testplanDataList.result
        ? state.testplanDataList.result
        : state.testplanDataList;
    });

    testplanActions
      .getAll(
        false,
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        const testPlanDropdownList: any[] = [];
        this._testplanDropdownList.forEach((element: ITestplanViewData) => {
          testPlanDropdownList.push({
            label: element.name,
            value: element.id,
          });
        });

        this.setState(
          {
            testPlanDropdownList,
          },
          () => {
            this.setState(
              {
                gradeFormData: {
                  ...this.state.gradeFormData,
                  selectedTestplan: this.state.gradeFormData.selectedTestplan,
                },
              },
              () => {
                if (this.state.gradeFormData.testplan.id !== "") {
                  testplanActions
                    .getById(this.state.gradeFormData.testplan.id)
                    .then(() => {
                      const instrumentDropdownList: any[] = [];

                      this._selectedTestplan.instruments.forEach((element) => {
                        instrumentDropdownList.push({
                          label: element.name,
                          value: element.id,
                        });
                      });
                      this.setState(
                        {
                          instrumentDropdownList,
                        },
                        () => {
                          if (this.state.gradeFormData.isEditMode) {
                            const uniqueArray =
                              this.state.gradeFormData.selectedInstruments.filter(
                                (object, index) =>
                                  index ===
                                  this.state.gradeFormData.selectedInstruments.findIndex(
                                    (obj) =>
                                      JSON.stringify(obj) ===
                                      JSON.stringify(object)
                                  )
                              );
                            this.setState({
                              gradeFormData: {
                                ...this.state.gradeFormData,
                                selectedInstruments: uniqueArray,
                              },
                            });
                          } else {
                            this.setState({
                              gradeFormData: {
                                ...this.state.gradeFormData,
                                selectedInstruments:
                                  this.state.gradeFormData.selectedInstruments,
                              },
                            });
                          }
                        }
                      );
                    })
                    .catch((error) => {
                      triggerNotifications
                        .errors(error.message, error.data)
                        .then();
                    });
                }
              }
            );
          }
        );
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });

    instrumentSelectedIdStore.on(CHANGE_EVENT, (state) => {
      this._fetchedInstruments = state.instrumentDataList.result
        ? state.instrumentDataList.result
        : state.instrumentDataList;
      console.log(state.instrumentDataList);
    });

    propertySelectedIdStore.on(CHANGE_EVENT, (state) => {
      this._fetchedProperties = state.data.result
        ? state.data.result
        : state.data;
    });

    propertySelectedCalculatedIdStore.on(CHANGE_EVENT, (state) => {
      this._fetchedCalculatedProperties = state.data.result
        ? state.data.result
        : state.data;
      this.setState({
        fetchedCalculatedProperties: state.data.result
          ? state.data.result
          : state.data
      })
    });

    calculatedPropertyDetailsIdStore.on(CHANGE_EVENT, (state) => {
      this._calculatedPropertyDetails = [];
      this._calculatedPropertyDetails = state.data.result
        ? state.data.result
        : state.data;
    });

    calculatedPropertySourceListStore.on(CHANGE_EVENT, (state) => {
      this._readingSourceDropdown = state.propertyDataList.result
        ? state.propertyDataList.result
        : state.propertyDataList;
    });

    calculatedPropertyValuesListStore.on(CHANGE_EVENT, (state) => {
      this._readingValuesDropdown = state.propertyDataList.result
        ? state.propertyDataList.result
        : state.propertyDataList;
    });

    partitionsDetailsListStore.on(CHANGE_EVENT, (state) => {
      this._partitionListData = state.data.result
        ? state.data.result
        : state.data;
    });

    gradeFormStore.on(CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._id = state.gradeId;
        this._messages = state.message;
      }
    });
  }

  componentDidUpdate() {
    const oldDataT = {
      id: this.state.oldData.id,
      name: this.state.oldData.name,
      description: this.state.oldData.description,
      code: this.state.oldData.code,
      testplan: this.state.oldData.testplan,
      properties: this.state.oldData.properties,
      sourceMappings: this.state.oldData.sourceMappings,
    };
    const gradeFormDataNew = {
      id: this.state.gradeFormData.id,
      name: this.state.gradeFormData.name,
      description: this.state.gradeFormData.description,
      code: this.state.gradeFormData.code,
      testplan: this.state.gradeFormData.testplan,
      properties: this.state.gradeFormData.properties,
      sourceMappings: this.state.gradeFormData.sourceMappings,
    };
    if (JSON.stringify(oldDataT) !== JSON.stringify(gradeFormDataNew)) {
      navigationHeaderActions
        .updateHeader({
          name: MODULE_GRADE,
          action: this.state.gradeFormData.isEditMode ? EDIT : CREATE,
          icon: this.state.gradeFormData.isEditMode ? ABB_EDIT : ABB_PLUS,
          goBackUrl: GRADE_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: true,
        })
        .then();
    }
  }

  componentWillUnmount() {
    this._mount = false;
    document.removeEventListener("mousedown", this.onCloseAll);
  }

  validateCalculatedPropertyDetails = () => {
    let isEmpty = true;

    for (let i = 0; i < this.state.calculatedPropertyDetails.length; i++) {
      for (
        let j = 0;
        j < this.state.calculatedPropertyDetails[i].variables.length;
        j++
      ) {
        if (
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource &&
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource[0]
            ?.label === "Individual"
        ) {
          if (
            !this.state.calculatedPropertyDetails[i].variables[j].selectedValue
              ?.length
          ) {
            isEmpty = false;
            break;
          }
        } else if (
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource &&
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource[0]
            ?.label === "Position"
        ) {
          if (
            !this.state.calculatedPropertyDetails[i].variables[j]
              .selectedPosition?.length
          ) {
            isEmpty = false;
            break;
          }
          if (
            !this.state.calculatedPropertyDetails[i].variables[j].selectedValue
              ?.length
          ) {
            isEmpty = false;
            break;
          }
        } else if (
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource &&
          this.state.calculatedPropertyDetails[i].variables[j].selectedSource[0]
            ?.label === "Series"
        ) {
          if (
            !this.state.calculatedPropertyDetails[i].variables[j].selectedValue
              ?.length
          ) {
            isEmpty = false;
            break;
          }
        } else {
          isEmpty = false;
          break;
        }
        console.log(isEmpty);
      }
      console.log(isEmpty);
    }
    return isEmpty;
  };

  validate(): void {
    if (
      !this.state.nameError &&
      !this.state.codeError &&
      this.state.gradeFormData.name &&
      this.state.gradeFormData.name.trim() &&
      this.state.gradeFormData.name.length > 1 &&
      this.state.gradeFormData.testplan.id !== "" &&
      (this.state.gradeFormData.selectedInstruments.length > 0 ||
        this.state.gradeFormData.properties.length > 0) &&
      this.state.calculatedPropertyDetails.length === 0
    ) {
      submitHeaderActions
        .update({
          moduleName: MODULE_GRADE,
          isSubmitDisabled: false,
        })
        .then();
    } else if (this.validateCalculatedPropertyDetails()) {
      const dt: any[] = [];
      this.state.calculatedPropertyDetails.map((d) => {
        d.variables.map((v) => {
          v.attribute.name === "Measured Property"
            ? dt.push("measured")
            : dt.push("other");
        });
      });
      if (dt.some((x) => x === "measured")) {
        if (this._indexValueCount !== undefined) {
          submitHeaderActions
            .update({
              moduleName: MODULE_GRADE,
              isSubmitDisabled: false,
            })
            .then();
        } else {
          submitHeaderActions
            .update({
              moduleName: MODULE_GRADE,
              isSubmitDisabled: true,
            })
            .then();
        }
      } else if (dt.some((x) => x === "other")) {
        submitHeaderActions
          .update({
            moduleName: MODULE_GRADE,
            isSubmitDisabled: false,
          })
          .then();
      } else {
        submitHeaderActions
          .update({
            moduleName: MODULE_GRADE,
            isSubmitDisabled: true,
          })
          .then();
      }
    } else if (
      this.state.gradeFormData.isEditMode &&
      this.state.gradeFormData.name &&
      this.state.gradeFormData.name.trim() &&
      this.state.gradeFormData.code &&
      this.state.gradeFormData.testplan.id !== ""
    ) {
      if (this.validateCalculatedPropertyDetails()) {
        submitHeaderActions
          .update({
            moduleName: MODULE_GRADE,
            isSubmitDisabled: false,
          })
          .then();
      } else {
        submitHeaderActions
          .update({
            moduleName: MODULE_GRADE,
            isSubmitDisabled: true,
          })
          .then();
      }
    } else {
      submitHeaderActions
        .update({
          moduleName: MODULE_GRADE,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  onCancelClick = () => {
    History.push(GRADE_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };
  onCreateClick = () => {
    const tempName = this.state.gradeFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.updatePropertiesOrder();
    this.setState(
      (prevState) => ({
        formLoading: true,
        gradeFormData: {
          ...prevState.gradeFormData,
          name: tempName,
        },
      }),
      () => {
        gradeActions
          .post(this.state.gradeFormData)
          .then((id: any) => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                var productFormData = new ProductFormData(
                  uuidv4(),
                  this.state.gradeFormData.isEditMode,
                  "",
                  this.state.gradeFormData.name,
                  this.state.gradeFormData.description,
                  this.state.gradeFormData.code,
                  new GradeBasicData(
                    this._id,
                    this.state.gradeFormData.name,
                    this.state.gradeFormData.description,
                    this.state.gradeFormData.code,
                    true
                  ),
                  [],
                  [],
                  []
                );

                productFormData.properties =
                  this.state.gradeFormData.properties;

                productActions
                  .post(productFormData)
                  .then(() => {
                    this.setState(
                      {
                        formLoading: false,
                      },
                      () => {
                        triggerNotifications
                          .success([
                            i18next.t("Grade and Product created successfully with name ") +
                            productFormData.name,
                          ])
                          .then();
                        setTimeout(() => {
                          History.push(GRADE_INDEX_URL, {
                            isReloadFirst: this._isReload,
                            id: this._id,
                          });
                        }, NOTIFICATION_TIMEOUT);
                      }
                    );
                  })
                  .catch((error) => {
                    this.setState(
                      {
                        formLoading: false,
                      },
                      () => {
                        triggerNotifications
                          .success(this._messages)
                          .then(() => {
                            setTimeout(() => {
                              triggerNotifications
                                .errors(error.message, error.data)
                                .then(() => {
                                  setTimeout(() => {
                                    triggerNotifications
                                      .errors(error.message, error.data)
                                      .then(() => {
                                        History.push(GRADE_INDEX_URL, {
                                          isReloadFirst: this._isReload,
                                          id: this._id,
                                        });
                                      });
                                  }, NOTIFICATION_TIMEOUT);
                                });
                            }, NOTIFICATION_TIMEOUT);
                          });
                      }
                    );
                  });
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.errors(error.message, error.data).then();
              }
            );
          });
      }
    );
  };

  onSaveClick = () => {
    const tempName = this.state.gradeFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.updatePropertiesOrder();
    this.setState(
      (prevState) => ({
        formLoading: true,
        gradeFormData: {
          ...prevState.gradeFormData,
          name: tempName,
        },
      }),
      () => {
        gradeActions
          .put(this.state.gradeFormData)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  History.push(GRADE_INDEX_URL, {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.errors(error.message, error.data).then();
              }
            );
          });
      }
    );
  };

  updatePropertiesOrder = () => {
    var propertyName = [];
    var rows = this.state.orderProperties;
    for (var i = 0; i < rows.length; i++) {
      var rowText = rows[i].firstChild.textContent;
      propertyName.push(rowText);
    }
    propertyName.shift();

    const properties = [...this.state.gradeFormData.properties];
    for (var j = 0; j < propertyName.length; j++) {
      const name: string = propertyName[j];
      for (var n = 0; n < properties.length; n++) {
        if (properties[n].propertyName === name) {
          properties[n].order = j + 1;
          break;
        }
      }
    }
    this.setState({
      gradeFormData: { ...this.state.gradeFormData, properties },
    });
  };

  private setPropertiesOrderNo = (rowData: any[]) => {
    this.setState({
      orderProperties: rowData,
    });
  };

  setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      value.trim() &&
      !rgFile.test(value)
    ) {
      this.setState(
        {
          nameError: false,
          gradeFormData: {
            ...this.state.gradeFormData,
            name: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          nameError: true,
          gradeFormData: {
            ...this.state.gradeFormData,
            name: val,
          },
        },
        this.validate
      );
    }
  };

  setDescription = (value: string) => {
    this.setState(
      {
        gradeFormData: {
          ...this.state.gradeFormData,
          description: value,
        },
      },
      this.validate
    );
  };

  setCode = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() === "" || (!rgFile.test(value) && value.trim())) {
      this.setState(
        {
          codeError: false,
          gradeFormData: {
            ...this.state.gradeFormData,
            code: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          codeError: true,
          gradeFormData: {
            ...this.state.gradeFormData,
            code: val,
          },
        },
        this.validate
      );
    }
  };

  testPlanChangeHandler = (values: any) => {
    this._tempTestplan = values;
    if (this.state.gradeFormData.testplan.id === "") {
      this.performTestplanChange(this._tempTestplan);
    } else {
      this.setState({
        modalWarningTestplanChange: true,
      });
    }
  };

  triggerTestplanChange = () => {
    this.setState(
      {
        modalWarningTestplanChange: false,
      },
      () => {
        this.performTestplanChange(this._tempTestplan);
      }
    );
  };

  thresholdvalue = () => {
    this.setState({ showthreshold: true, showformula: false });
  };

  formuladefinition = () => {
    this.setState({ showformula: !this.state.showformula });
  };

  associationAction = () => {
    navigationHeaderActions
      .updateHeader({
        name: MODULE_PROPERTY,
        action: ASSOCIATE,
        icon: ABB_PLUS,
        goBackUrl: GRADE_CREATE_URL,
        isGoBackWithData: true,
        goBackData: this.state.gradeFormData,
      })
      .then();
    History.push(GRADE_ASSOCIATE_PROPERTY_URL, {
      gradeFormData: this.state.gradeFormData,
      allCalculatedDropdownList: this.state.allCalculatedDropdownList,
      instrumentDropdownList: this.state.instrumentDropdownList,
    });
  };

  getAllCalculatedPropertiesEdit = () => {
    const calculatedIds: string[] = [];

    this.state.gradeFormData.properties.map((id, index) => {
      calculatedIds.push(id.propertyId);
    });
    propertyActions.getSelectedCalculated(calculatedIds).then(() => {
      const allCalculatedDropdownList: any[] = [];
      this._fetchedCalculatedProperties.forEach(
        (element: IPropertyViewData) => {
          allCalculatedDropdownList.push({
            label: element.name,
            value: element.id,
            disabled: false,
          });
        }
      );
      this.setState({
        allCalculatedDropdownList,
      });
    });
  };

  getCalculatedPropertiesEdit = () => {
    const calculatedIds: string[] = [];

    this.state.gradeFormData.properties.map((id, index) => {
      calculatedIds.push(id.propertyId);
    });

    propertyActions.getSelectedCalculated(calculatedIds).then(() => {
      const calculatedDropdownList: any[] = [];
      const calculatedList: any[] = [];
      let fetchedCalculatedProperties: any[] = [];
      this._fetchedCalculatedProperties.forEach(
        (element: IPropertyViewData) => {
          calculatedDropdownList.push({
            label: element.name,
            value: element.id,
          });
          calculatedList.push(element.id);

          fetchedCalculatedProperties.push(
            new PropertySpecification(
              false,
              true,
              "",
              element.id,
              element.name,
              element.customId,
              "",
              "",
              1,
              0,
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              []
            )
          );
        }
      );

      const removeCalculatedPropertiesList =
        this.state.gradeFormData.properties.filter((obj) => !obj.isCalculated);
      const arr: any = [
        ...removeCalculatedPropertiesList,
        ...fetchedCalculatedProperties,
      ];

      // All values of calculated dropdownlist
      const allCalculatedDropdownList =
        this.state.allCalculatedDropdownList.map((item) => {
          if (calculatedList.includes(item.value)) {
            item.disabled = false;
          } else {
            item.disabled = true;
          }
          return item;
        });

      this.setState({
        allCalculatedDropdownList,
        selectedCalculatedProperties: calculatedDropdownList,
        gradeFormData: { ...this.state.gradeFormData, properties: arr },
      });
    });
  };

  getCalculatedPropertyDetails = (calculatedProperties: any[]) => {
    if (!this.state.gradeFormData?.isEditMode) {
      const selectedCalculated: any[] = [];
      let calculatedPropertyDetails: ICalculatedPropertyViewData[] = [];
      let properties: IPropertySpecification[] = [];

      let isNext: boolean = false;
      if (Array.isArray(calculatedProperties) &&
        calculatedProperties.length > 0) {
        calculatedProperties.map((data: any) => {
          const value = {
            label:
              data.property === undefined
                ? data.propertyName
                : data.property.name,
            value:
              data.property == undefined ? data.propertyId : data.property.id,
          };

          if (data.formulaMappings !== undefined) {
            let selectedSource: any[] = [];
            let selectedValue: any[] = [];
            let selectedPosition: string;
            let disablePosition = false;
            let disableValue = false;
            let disableSource = false;
            let id = "";
            let variable = "";
            let attribute: IAttributeData = { id: "", name: "" };
            let property: IPropertyData = {
              id: "",
              name: "",
              customId: "",
            };
            const variableMapData: IVariableData[] = [];
            data.formulaMappings[0].variableMapping.map(
              (variables: any, i: number) => {
                let randomNumber = Math.random();
                if (
                  variables.variableMapping?.source !== null &&
                  variables.variableMapping?.value !== null
                ) {
                  if (variables.attribute.name !== "Measured Property") {
                    disablePosition = true;
                    disableValue = true;
                    disableSource = true;
                  }
                  if (
                    variables.variableMapping?.source?.name === "Individual"
                  ) {
                    disablePosition = true;
                    disableValue = true;
                    selectedSource =
                      variables.variableMapping.source !== null
                        ? [
                          {
                            label: variables.variableMapping.source.name,
                            value: variables.variableMapping.source.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables.variableMapping.value !== null
                        ? [
                          {
                            label: variables.variableMapping.value.name,
                            value: variables.variableMapping.value.id,
                          },
                        ]
                        : [];
                  } else if (
                    variables.variableMapping?.source?.name === "Position"
                  ) {
                    const testplanId = this.state.gradeFormData.testplan.id;
                    const calculatedId = data.property?.id;
                    const propertyId = variables.property.id;
                    calculatedPropertyActions
                      .getPartitions(calculatedId, propertyId, testplanId)
                      .then(() => {
                        if (this._partitionName.length > 0) {
                          this._oldPartitionName = this._partitionName;
                        }
                        this._partitionListData.partitions.map(
                          (partitionName: any) => {
                            this._partitionName.push({
                              label: partitionName.name,
                              value:
                                partitionName.position + `(${randomNumber})`,
                            });
                          }
                        );
                        this.setState({}, () => {
                          this.forceUpdate();
                        });
                      })
                      .catch((error) => {
                        triggerNotifications
                          .errors(error.message, error.data)
                          .then();
                      });

                    disablePosition = false;
                    disableValue = false;
                    selectedSource =
                      variables.variableMapping?.source !== null
                        ? [
                          {
                            label: variables.variableMapping?.source.name,
                            value: variables.variableMapping?.source.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables.variableMapping?.value !== null
                        ? [
                          {
                            label: variables.variableMapping?.value.name,
                            value: variables.variableMapping?.value.id,
                          },
                        ]
                        : [];
                    selectedPosition =
                      variables.variableMapping.position !== null
                        ? variables.variableMapping.position +
                        `(${randomNumber})`
                        : "";
                  } else {
                    disablePosition = true;
                    disableValue = false;
                    selectedSource =
                      variables.variableMapping?.source !== null
                        ? [
                          {
                            label: variables.variableMapping?.source.name,
                            value: variables.variableMapping?.source.id,
                          },
                        ]
                        : [];

                    selectedValue =
                      variables.variableMapping?.value !== null
                        ? [
                          {
                            label: variables.variableMapping?.value.name,
                            value: variables.variableMapping?.value.id,
                          },
                        ]
                        : [];
                  }
                } else {
                  disablePosition = true;
                  disableValue = true;
                  disableSource = true;
                  selectedSource = [];
                  selectedValue = [];
                  selectedPosition = "";
                }
                id = variables.id;
                variable = variables.variable;
                attribute = variables.attribute;
                property = variables.property;
                const varData = {
                  id,
                  variable,
                  attribute,
                  property,
                  selectedSource,
                  selectedValue,
                  selectedPosition,
                  disablePosition,
                  disableValue,
                  disableSource,
                };
                variableMapData.push(varData);
                selectedSource = [];
                selectedValue = [];
                selectedPosition = "";
              }
            );

            const calculatedPropertyDetailData = new CalculatedPropertyViewData(
              data.property?.id,
              data.property?.name,
              String(data.formulaMappings[0].formula),
              variableMapData
            );

            calculatedPropertyDetails.push(calculatedPropertyDetailData);
          }

          selectedCalculated.push(value);

          const property = this.state.gradeFormData.properties.find(
            (x) => x.propertyId === data.property?.id
          );
          const propertyIndex = this.state.gradeFormData.properties.findIndex(
            (x) => x.propertyId === data.property?.id
          );

          if (property !== undefined) {
            if (data.formulaMappings !== undefined) {
              let sourceMapping: any[] = []
              data.formulaMappings[0].variableMapping.map((variables: any) => {
                const sourceId =
                  variables.variableMapping?.source === null
                    ? ""
                    : variables.variableMapping?.source.id;
                const position =
                  variables.variableMapping?.position === null
                    ? ""
                    : variables.variableMapping?.position;
                const valueId =
                  variables.variableMapping?.value === null
                    ? ""
                    : variables.variableMapping?.value.id;
                const sourceMappingData = {
                  sourceId,
                  position,
                  valueId,
                  propertyAttributeId: variables.attribute.id,
                  propertyId: variables.property.id,
                  variable: variables.variable,
                };
                sourceMapping.push(sourceMappingData)
              });
              sourceMapping.forEach((element: IGradeCalculatedData) => {
                const itemIndex = this.state.gradeFormData.properties[
                  propertyIndex
                ].sourceMappings.findIndex(o => o.propertyId === element.propertyId);
                if (itemIndex > -1) {
                  this.state.gradeFormData.properties[
                    propertyIndex
                  ].sourceMappings[itemIndex] = element;
                } else {
                  this.state.gradeFormData.properties[
                    propertyIndex
                  ].sourceMappings.push(element)
                }
              });
            }
            properties = this.state.gradeFormData.allProperties.length
              ? this.state.gradeFormData.allProperties
              : this.state.gradeFormData.properties;
          }
          properties = this.state.gradeFormData.properties;
          isNext = true;
        });
      } else {
        properties = this.state.gradeFormData.allProperties.length
          ? this.state.gradeFormData.allProperties
          : this.state.gradeFormData.properties;
        isNext = false;
      }
      this._testplanproperties = properties.filter(
        (x) => x.isCalculated !== true
      );

      const selectedCalculatedProperties: any[] = [];
      if (Array.isArray(calculatedProperties) &&
        calculatedProperties.length) {
        calculatedProperties.map((item: any) => {
          if (item.propertyId) {
            // property specification
            selectedCalculatedProperties.push({
              label: item.propertyName,
              value: item.propertyId,
            });
          } else {
            // calculated specification
            selectedCalculatedProperties.push({
              label: item.property.name,
              value: item.property.id,
            });
          }
        });
      }

      calculatedPropertyDetails.forEach((el) => {
        if (
          el.variables.find(
            (ele) => ele.attribute?.name === "Measured Property"
          )
        ) {
          this._indexValueCount = calculatedPropertyDetails.length;
        }
      });

      this.setState(
        {
          isNext,
          calculatedPropertyDetails,
          selectedCalculatedProperties,
          gradeFormData: {
            ...this.state.gradeFormData,
            properties
          }
        }
      );
    }
  }
  performTestplanChange = (values: any) => {
    testplanActions
      .getById(values[0].value)
      .then(() => {
        this.setState(
          {
            selectedCalculatedProperties: [],
            gradeFormData: {
              ...this.state.gradeFormData,
              selectedTestplan: [],
              selectedInstruments: [],
              properties: [],
              allInstruments: [],
              allProperties: [],
            },
          },
          () => {
            const instrumentDropdownList: any[] = [];
            const selectedCalculatedProperties: any[] = [];
            this._selectedTestplan.instruments.forEach((d) => {
              instrumentDropdownList.push({
                label: d.name,
                value: d.id,
              });
            });
            this._selectedTestplan.calculatedProperties?.forEach((d) => {
              selectedCalculatedProperties.push({
                label: d.property.name,
                value: d.property.id,
              });
            });
            this.setState(
              {
                instrumentDropdownList,
                selectedCalculatedProperties
              },
              () => {
                const instrumentsToBeFetched: string[] = [];
                this.state.instrumentDropdownList.forEach((item) => {
                  instrumentsToBeFetched.push(item.value);
                });

                instrumentActions
                  .getSelected(instrumentsToBeFetched)
                  .then(() => {
                    const selectedTestplan = [
                      {
                        label: this._selectedTestplan.name,
                        value: this._selectedTestplan.id,
                      },
                    ];
                    const selectedInstruments: any[] = [];
                    this._fetchedInstruments.forEach(
                      (instrument: IInstrumentViewData) => {
                        selectedInstruments.push({
                          label: instrument.name,
                          value: instrument.id,
                        });
                      }
                    );

                    const propertiesToBeFetched: string[] = [];
                    this._selectedTestplan.keyedIns.forEach(
                      (property: IKeyedInProperty) => {
                        propertiesToBeFetched.push(property.id);
                      }
                    );

                    propertyActions
                      .getSelected(propertiesToBeFetched)
                      .then(() => {
                        const properties: IPropertySpecification[] = [];
                        const allProperties: IPropertySpecification[] = [];

                        this._fetchedInstruments.forEach(
                          (i: IInstrumentViewData) => {
                            i.properties.forEach((p: any) => {
                              const direction =
                                p.direction.name != CONSTANTS.ND
                                  ? p.direction.name
                                  : "";
                              const pName =
                                p.name + " (" + i.codeId + ")" + direction;
                              const max =
                                p.max === null || p.max === 0
                                  ? ""
                                  : String(p.max);
                              const min =
                                p.min === null || p.min === 0
                                  ? ""
                                  : String(p.min);
                              properties.push(
                                new PropertySpecification(
                                  true,
                                  false,
                                  i.id,
                                  p.id,
                                  pName,
                                  p.customId,
                                  "",
                                  "",
                                  1,
                                  0,
                                  min,
                                  max,
                                  "",
                                  "",
                                  "",
                                  "",
                                  "",
                                  "",
                                  [],
                                  p.direction
                                )
                              );
                              allProperties.push(
                                new PropertySpecification(
                                  true,
                                  false,
                                  i.id,
                                  p.id,
                                  pName,
                                  p.customId,
                                  "",
                                  "",
                                  1,
                                  0,
                                  min,
                                  max,
                                  "",
                                  "",
                                  "",
                                  "",
                                  "",
                                  "",
                                  [],
                                  p.direction
                                )
                              );
                            });
                          }
                        );

                        this._fetchedProperties.forEach(
                          (p: IPropertyViewData) => {
                            properties.push(
                              new PropertySpecification(
                                false,
                                false,
                                "",
                                p.id,
                                p.name,
                                p.customId,
                                "",
                                "",
                                1,
                                0,
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                []
                              )
                            );
                            allProperties.push(
                              new PropertySpecification(
                                false,
                                false,
                                "",
                                p.id,
                                p.name,
                                p.customId,
                                "",
                                "",
                                1,
                                0,
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                []
                              )
                            );
                          }
                        );

                        // update the properties order number in create mode
                        if (!this.state.gradeFormData.isEditMode) {
                          for (let i = 0; i < properties.length; i++) {
                            properties[i].order = i + 1;
                          }
                        }
                        const testplan = new TestplanBasicData(
                          this._selectedTestplan.id,
                          this._selectedTestplan.name,
                          this._selectedTestplan.description,
                          this._selectedTestplan.codeId,
                          this._selectedTestplan.isEnabled
                        );

                        this.setState(
                          {
                            gradeFormData: {
                              ...this.state.gradeFormData,
                              testplan,
                              selectedTestplan,
                              selectedInstruments,
                              properties,
                              allProperties,
                            },
                          },
                          () => {
                            this.validate();
                            this._testplanproperties = properties;
                            const calculatedIds: string[] = [];
                            this.state.gradeFormData.properties.map(
                              (id, index) => {
                                calculatedIds.push(id.propertyId);
                              }
                            );

                            propertyActions
                              .getSelectedCalculated(calculatedIds)
                              .then(() => {
                                const calculatedDropdownList: any[] = [];
                                this._fetchedCalculatedProperties.forEach(
                                  (element: IPropertyViewData) => {
                                    calculatedDropdownList.push({
                                      label: element?.name,
                                      value: element?.id,
                                    });
                                  }
                                );
                                this.setState({
                                  calculatedDropdownList,
                                  allCalculatedDropdownList:
                                    calculatedDropdownList,
                                  showformula: false
                                }, () => {
                                  this.setCalculatedPropertyDetails(selectedCalculatedProperties)
                                });
                              });
                          }
                        );
                      })
                      .catch((error) => {
                        triggerNotifications
                          .errors(error.message, error.data)
                          .then();
                      });
                  })
                  .catch((error) => {
                    triggerNotifications
                      .errors(error.message, error.data)
                      .then();
                  });
              }
            );
          }
        );
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private onChangeValue = (e: any, rowIndex: number, colIndex: number) => {
    const name = e === "sigmaPercent" ? e : e.target.name;

    const properties = [...this.state.gradeFormData.properties];
    const item: any = properties[rowIndex];

    if (name.indexOf(".") !== -1) {
      const data = e.target.name.split(".");
      let result: any = item;
      for (let index = 0; index < data.length - 1; index++) {
        result = result[data[index]];
      }
      const targetVal = e.target.value;
      result[data[data.length - 1]] = targetVal;
    } else if (name === "sigmaPercent") {
      item["sigmaPercent"] = !item["sigmaPercent"];
    } else {
      const targetVal = e.target.value;
      item[e.target.name] = targetVal;
    }

    if (item["sigma"] && item["target"]) {
      if (item["sigmaPercent"]) {
        const sigma = parseFloat(item["sigma"]);
        const temp = (parseFloat(item["target"]) * sigma) / 100;
        item["alarmLow1"] = (parseFloat(item["target"]) - temp).toString();
        item["alarmHigh1"] = (parseFloat(item["target"]) + temp).toString();
      } else {
        if (
          item["sigma"].length &&
          item["target"].length &&
          (e === "sigmaPercent" ||
            e.target.name === "sigma" ||
            e.target.name === "target")
        ) {
          item["alarmLow1"] = (
            parseFloat(item["target"]) - parseFloat(item["sigma"])
          ).toString();
          item["alarmHigh1"] = (
            parseFloat(item["target"]) + parseFloat(item["sigma"])
          ).toString();
        }
      }
    }
    properties[rowIndex] = item;
    this.setState(
      {
        gradeFormData: { ...this.state.gradeFormData, properties },
      },
      () => {
      }
    );
  };

  private onBlurValue = (e: any, rowIndex: number, colIndex: number) => {
    const properties = [...this.state.gradeFormData.properties];

    // reverse case for min and max value
    if (
      properties[rowIndex].minValue &&
      properties[rowIndex].minValue &&
      Number(properties[rowIndex].minValue) !== 0 &&
      Number(properties[rowIndex].maxValue) !== 0 &&
      Number(properties[rowIndex].maxValue) <
      Number(properties[rowIndex].minValue)
    ) {
      triggerNotifications.error(CONSTANTS.MIN_MAX_ERROR);
    }

    // rejectHigh
    if (
      properties[rowIndex].rejectLow &&
      properties[rowIndex].minValue &&
      Number(properties[rowIndex].rejectLow) !== 0 &&
      Number(properties[rowIndex].rejectLow) <=
      Number(properties[rowIndex].minValue)
    ) {
      triggerNotifications.error(CONSTANTS.REJECT_LOW_MIN_ERROR);
    }
    if (
      properties[rowIndex].rejectHigh &&
      properties[rowIndex].maxValue &&
      Number(properties[rowIndex].rejectHigh) !== 0 &&
      Number(properties[rowIndex].rejectHigh) >=
      Number(properties[rowIndex].maxValue)
    ) {
      triggerNotifications.error(CONSTANTS.REJECT_HIGH_MAX_ERROR);
    }

    // alarm low 2
    if (
      properties[rowIndex].rejectLow &&
      properties[rowIndex].alarmLow2 &&
      Number(properties[rowIndex].alarmLow2) !== 0 &&
      Number(properties[rowIndex].alarmLow2) <=
      Number(properties[rowIndex].rejectLow)
    ) {
      triggerNotifications.error(CONSTANTS.LOW_REJECT_LOW_ERROR);
    }

    if (
      properties[rowIndex].alarmHigh2 &&
      properties[rowIndex].rejectHigh &&
      Number(properties[rowIndex].alarmHigh2) !== 0 &&
      Number(properties[rowIndex].alarmHigh2) >=
      Number(properties[rowIndex].rejectHigh)
    ) {
      triggerNotifications.error(CONSTANTS.HIGH_REJECT_HIGH_ERROR);
    }

    // low1
    if (
      properties[rowIndex].alarmLow1 &&
      properties[rowIndex].alarmLow2 &&
      Number(properties[rowIndex].alarmLow1) !== 0 &&
      Number(properties[rowIndex].alarmLow2) !== 0 &&
      Number(properties[rowIndex].alarmLow2) >=
      Number(properties[rowIndex].alarmLow1)
    ) {
      triggerNotifications.error(i18next.t(CONSTANTS.LOW1_LOW2_ERROR));
    }

    if (
      properties[rowIndex].alarmHigh2 &&
      properties[rowIndex].alarmHigh1 &&
      Number(properties[rowIndex].alarmHigh2) !== 0 &&
      Number(properties[rowIndex].alarmHigh1) !== 0 &&
      Number(properties[rowIndex].alarmHigh2) <=
      Number(properties[rowIndex].alarmHigh1)
    ) {
      triggerNotifications.error(i18next.t(CONSTANTS.HIGH1_HIGH2_ERROR));
    }
  };

  private onChangeInstrument = (value: any) => {
    const property: any = [];
    const keyedInProperty: any = [];
    this._testplanproperties.forEach((item: any) => {
      value.forEach((val: any) => {
        if (val.value == item.instrumentId) {
          // As keyedIn property will always has instrumentId empty
          property.push(item);
        }
      });
      if (item.instrumentId == "" && item.propertyName) {
        keyedInProperty.push(item);
      }
    });
    const uniquekeyedInProperty = Array.from(new Set(keyedInProperty));
    this.setState(
      {
        gradeFormData: {
          ...this.state.gradeFormData,
          selectedInstruments: [...value],
          properties: [...property, ...uniquekeyedInProperty],
        },
      },
      () => {
      }
    );
  };

  private calculatePropertyAddition = (value: any) => {
    const calculatedDetailsIds: string[] = [];
    value.map((id: any) => {
      calculatedDetailsIds.push(id.value);
    });
    if (calculatedDetailsIds.length > 0) {
      calculatedPropertyActions
        .getSelected(calculatedDetailsIds, this.state.gradeFormData.selectedTestplan[0].value)
        .then(() => {
          let sourceMappings: any[] = [];
          let properties: IPropertySpecification[] = [];
          if (this.state.gradeFormData.properties !== undefined) {
            properties = [
              ...this.state.gradeFormData.properties.filter(
                (x) => !x.isCalculated
              ),
            ];
          }
          // Pushing calculated properties to table
          if (value.length > 0) {
            value.forEach((item: any) => {
              const property = properties.find(
                (x) => x.propertyId === item.value
              );
              if (property === undefined) {
                this._calculatedPropertyDetails.forEach(
                  (c: ICalculatedPropertyViewData) => {
                    if (item.value === c.id) {
                      sourceMappings = [];
                      c.variables.map(
                        (sourceData: IVariableData, index: any) => {
                          sourceMappings.push({
                            sourceId: "",
                            valueId: "",
                            position: "",
                            propertyId: sourceData.property.id,
                            propertyAttributeId: sourceData.attribute.id,
                            variable: sourceData.variable,
                            calculatedId: c.id,
                          });
                          c.onSourceDropdownAsPerAttribute(
                            sourceData.attribute.name,
                            index
                          );
                        }
                      );
                      const customId = this.state?.fetchedCalculatedProperties?.find(
                        (item: any) => {
                          return item.id == c.id;
                        }
                      );
                      properties.push(
                        new PropertySpecification(
                          false,
                          true,
                          "",
                          c.id,
                          c.name,
                          customId?.customId,
                          "",
                          "",
                          1,
                          0,
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          sourceMappings
                        )
                      );
                    }
                  }
                );
              } else {
                properties.push(property);
              }
            });
            // update the properties order number in create mode
            if (!this.state.gradeFormData.isEditMode) {
              for (let i = 0; i < properties.length; i++) {
                properties[i].order = i + 1;
              }
            }
          }

          this.setState(
            {
              gradeFormData: {
                ...this.state.gradeFormData,
                sourceMappings,
                properties,
              },
            },
            () => {
              this.validate();
              this.getCalculatedPropertyDetails(this.state?.gradeFormData?.calculatedPropertyDetails?.calculatedProperties)
            }
          );
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }
  }

  private calculateChangeHandler = (value: any) => {
    const calculatedDetailsIds: string[] = [];
    value.map((id: any) => {
      calculatedDetailsIds.push(id.value);
    });
    if (calculatedDetailsIds.length > 0) {
      calculatedPropertyActions
        .getSelected(calculatedDetailsIds, this.state.gradeFormData.selectedTestplan[0].value)
        .then(() => {
          let sourceMappings: any[] = [];
          let properties: IPropertySpecification[] = [];
          if (this.state.gradeFormData.properties !== undefined) {
            properties = [
              ...this.state.gradeFormData.properties.filter(
                (x) => !x.isCalculated
              ),
            ];
          }
          // Pushing calculated properties to table
          if (value.length > 0) {
            value.forEach((item: any) => {
              const property = properties.find(
                (x) => x.propertyId === item.value
              );
              if (property === undefined) {
                this._calculatedPropertyDetails.forEach(
                  (c: ICalculatedPropertyViewData) => {
                    if (item.value === c.id) {
                      sourceMappings = [];
                      c.variables.map(
                        (sourceData: IVariableData, index: any) => {
                          sourceMappings.push({
                            sourceId: "",
                            valueId: "",
                            position: "",
                            propertyId: sourceData.property.id,
                            propertyAttributeId: sourceData.attribute.id,
                            variable: sourceData.variable,
                            calculatedId: c.id,
                          });
                          c.onSourceDropdownAsPerAttribute(
                            sourceData.attribute.name,
                            index
                          );
                        }
                      );
                      const customId = this.state?.fetchedCalculatedProperties?.find(
                        (item: any) => {
                          return item.id == c.id;
                        }
                      );
                      properties.push(
                        new PropertySpecification(
                          false,
                          true,
                          "",
                          c.id,
                          c.name,
                          customId?.customId,
                          "",
                          "",
                          1,
                          0,
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          "",
                          sourceMappings
                        )
                      );
                    }
                  }
                );
              } else {
                properties.push(property);
              }
            });
            // update the properties order number in create mode
            if (!this.state.gradeFormData.isEditMode) {
              for (let i = 0; i < properties.length; i++) {
                properties[i].order = i + 1;
              }
            }
          }

          this.setState(
            {
              calculatedPropertyDetails: this._calculatedPropertyDetails,
              selectedCalculatedProperties: value,
              gradeFormData: {
                ...this.state.gradeFormData,
                sourceMappings,
                properties,
              },
              isNext: true,
            },
            () => this.validate()
          );
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    } else {
      const properties = this.state.gradeFormData.properties.filter(
        (x) => x.isCalculated !== true
      );

      this.setState(
        {
          calculatedPropertyDetails: [],
          selectedCalculatedProperties: value,
          showformula: false,
          isNext: false,
          gradeFormData: {
            ...this.state.gradeFormData,
            properties,
          },
        },
        () => this.validate()
      );
    }
  }

  private setCalculatedPropertyDetails = (value: any) => {
    if (this._selectedTestplan?.calculatedProperties?.length > 0 ||
      this.state?.gradeFormData?.calculatedPropertyDetails?.calculatedProperties.length > 0) {
      this.calculatePropertyAddition(value)
    } else {
      this.calculateChangeHandler(value)
    }
  };

  private onNextClick = () => {
    if (this.state.gradeFormData.isEditMode || this._selectedTestplan?.calculatedProperties?.length > 0) {
      const calculatedPropertyDetails = [
        ...this.state.calculatedPropertyDetails,
      ];
      const calculatedPropertyDetail = calculatedPropertyDetails;
      calculatedPropertyDetail.map((item, index) => {
        item.variables.map((x, ids) => {
          const dt = this._partitionName.find(
            (y) => y.value === x.selectedPosition
          );
          x.selectedPosition = dt !== undefined ? dt.label : "";
        });
      });

      this.setState({
        calculatedPropertyDetails,
        gradeFormData: {
          ...this.state.gradeFormData,
        },
      });
    } else {
      const calculatedPropertyDetails = [
        ...this.state.calculatedPropertyDetails,
      ];
      const calculatedPropertyDetail = calculatedPropertyDetails;
      calculatedPropertyDetail.map((item, index) => {
        item.variables.map((x, ids) => {
          x.disablePosition = true;
        });
      });

      this.setState({
        calculatedPropertyDetails,
        gradeFormData: {
          ...this.state.gradeFormData,
        },
      });
    }

    this.setState(
      {
        showformula: !this.state.showformula,
        isStep: true,
      },
      () => {
        calculatedPropertyActions
          .getAllSource()
          .then(() => {
            this._readingSourceList = [];
            this._readingSourceDropdown.forEach((element: IReading) => {
              this._readingSourceList.push({
                label: element.name,
                value: element.id,
              });
            });
            this.setState(
              {
                readingSourceList: this._readingSourceList,
              },
              () => this.forceUpdate()
            );
          })
          .catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
          });

        calculatedPropertyActions
          .getAllValues()
          .then(() => {
            this._readingValuesList = [];
            this._readingValuesDropdown.forEach((element: IReading) => {
              this._readingValuesList.push({
                label: element.name,
                value: element.id,
                isNew: false,
              });
            });
            const valueList = this._readingValuesList.filter(
              (x) => x.label !== "Value"
            );

            this.setState(
              {
                readingValuesList: this._readingValuesList,
                valueList: valueList,
              },
              () => this.forceUpdate()
            );
          })
          .catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
          });
      }
    );
  };

  private onSourceChangeHandler(
    value: any,
    index: number,
    i: number,
    calculatedId: string
  ) {
    this.setState({
      isLoading: true,
    });

    this._indexSourceCount = i;
    const properties = this.state.gradeFormData.properties.find(
      (x) => x.propertyId === calculatedId
    );
    properties.sourceMappings[i].sourceId = value[0].value;
    const calculatedPropertyDetails = [...this.state.calculatedPropertyDetails];
    const calculatedPropertyDetail = calculatedPropertyDetails[index];
    const variables = calculatedPropertyDetail.variables;
    calculatedPropertyDetail.onSourceDropdown(value, i);
    variables[i].selectedSource = value;
    variables[i].selectedValue = [];

    if (value[0].label === "Position") {
      const propertyId = properties.sourceMappings[i].propertyId;
      const testplanId = this._selectedTestplan?.id;
      calculatedPropertyActions
        .getPartitions(calculatedId, propertyId, testplanId)
        .then(() => {
          if (this._partitionName.length > 0) {
            this._partitionName.map((x) => (x.disabled = true));
          }
          this._partitionListData.partitions.map(
            (partitionName: any, ids: any) => {
              this._partitionName.push({
                label: partitionName.name,
                value: partitionName.position + `(${Math.random()})`,
                disabled: false,
              });
            }
          );
          this.setState(
            {
              isLoading: false,
            },
            () => this.forceUpdate()
          );
        })
        .catch((error) => {
          this.setState(
            {
              isLoading: false,
            },
            () => {
              triggerNotifications.errors(error.message, error.data).then();
            }
          );
        });
    }

    if (value[0].label !== "Position") {
      variables[i].selectedPosition = "";
    }

    this.setState(
      {
        calculatedPropertyDetails,
        gradeFormData: {
          ...this.state.gradeFormData,
        },
      },
      () => {
        this.validate();
        if (value[0].label === "Individual") {
          const valuesDropDownList = this._readingValuesList.find(
            (x) => x.label === "Value"
          );
          this.onValuesChangeHandler(
            [valuesDropDownList],
            index,
            i,
            calculatedId
          );
          const readingValuesList: any[] = [];
          this._readingValuesList.map((x: any) => {
            if (x.label === "Value") {
              readingValuesList.push({
                label: x.label,
                value: x.value,
                isNew: false,
              });
            } else {
              readingValuesList.push({
                label: x.label,
                value: x.value,
                isNew: false,
              });
            }
          });
          this.setState({
            readingValuesList,
          });
        } else {
          const readingValuesList = this._readingValuesList.filter(
            (x) => x.label !== "Value"
          );
          this.setState({
            valueList: readingValuesList,
          });
        }
      }
    );
  }

  private onValuesChangeHandler(
    value: any,
    index: number,
    i: number,
    calculatedId: string
  ) {
    this._indexValueCount = i;
    const properties = this.state.gradeFormData.properties.find(
      (x) => x.propertyId === calculatedId
    );
    properties.sourceMappings[i].valueId = value[0].value;

    const calculatedPropertyDetails = [...this.state.calculatedPropertyDetails];
    const calculatedPropertyDetail = calculatedPropertyDetails[index];
    const variables = calculatedPropertyDetail.variables;
    variables[i].selectedValue = value;
    this.setState(
      {
        calculatedPropertyDetails,
        gradeFormData: {
          ...this.state.gradeFormData,
        },
      },
      this.validate
    );
  }
  private onEditPartitionChange(
    value: any,
    index: number,
    i: number,
    calculatedId: string
  ) {
    const allproperties = this.state.gradeFormData.properties.find(
      (x) => x.propertyId === calculatedId
    );
    const propertyId = allproperties.sourceMappings[i].propertyId;
    const testplanId = this._selectedTestplan?.id;
    calculatedPropertyActions
      .getPartitions(calculatedId, propertyId, testplanId)
      .then(() => {
        if (this._partitionName.length > 0) {
          this._partitionName.map((x) => (x.disabled = true));
        }
        this._partitionListData.partitions.map(
          (partitionName: any, ids: any) => {
            this._partitionName.push({
              label: partitionName.name,
              value: partitionName.position + `(${Math.random()})`,
              disabled: false,
            });
          }
        );
        this.setState({}, () => {
          this.forceUpdate();
        });
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  }

  private onCloseAll = (e: any) => {
    const dt: any = this.optionRef.current;
    const dy = dt?.contains(e.target);
    if (this.optionRef.current && !dy) {
      const calculatedPropertyDetails = [
        ...this.state.calculatedPropertyDetails,
      ];
      calculatedPropertyDetails.map((x) => {
        x.variables.map((y) => (y.isSelected = false));
      });
      this.setState({
        calculatedPropertyDetails,
        gradeFormData: {
          ...this.state.gradeFormData,
        },
      });
    }
  };

  private onToggleClick = (
    e: any,
    index: number,
    i: number,
    calculatedId: string
  ) => {
    e.preventDefault();
    const calculatedPropertyDetails = [...this.state.calculatedPropertyDetails];
    const calculatedPropertyDetail = calculatedPropertyDetails[index];
    const variables = calculatedPropertyDetail.variables;
    variables.map((x) => (x.isSelected = false));
    if (variables[i].isSelected === true) {
      variables[i].isSelected = false;
    } else {
      variables[i].isSelected = true;
    }
    this.setState(
      {
        calculatedPropertyDetails,
        gradeFormData: {
          ...this.state.gradeFormData,
        },
      },
      () => this.onEditPartitionChange(e, index, i, calculatedId)
    );
  };

  private onPartitionChangeHandler(
    value: any,
    index: number,
    i: number,
    calculatedId: string,
    selectedElement: any
  ) {
    this._indexPartitionCount = i;
    const properties = this.state.gradeFormData.properties.find(
      (x) => x.propertyId === calculatedId
    );
    properties.sourceMappings[i].position = selectedElement.value.replace(
      / *\([^)]*\) */g,
      ""
    );
    const calculatedPropertyDetails = [...this.state.calculatedPropertyDetails];
    const calculatedPropertyDetail = calculatedPropertyDetails[index];
    const variables = calculatedPropertyDetail.variables;
    variables[i].selectedPosition = selectedElement.label;
    variables[i].isSelected = false;
    this.setState(
      {
        calculatedPropertyDetails,
        gradeFormData: {
          ...this.state.gradeFormData,
        },
      },
      () => {
        this.validate();
      }
    );
  }

  public render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="page-scroll">
              <div className="layout-container">
                <SubmitHeader
                  name={t(MODULE_GRADE)}
                  link={CONSTANTS.PATH_GRADE}
                  isEdit={this.state.gradeFormData.isEditMode}
                  onSaveClick={this.onSaveClick}
                  onCreateClick={this.onCreateClick}
                  isLoading={this.state.formLoading}
                  onCancelClick={this.onCancelClick}
                />
                <div className="mt-4">
                  <div className="col-6 no-padding float-left">
                    <div className="box-1">
                      <div className="box-circle">
                        <p className="box-circle-text"> 1 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">
                          {t(CONSTANTS.MENU_GRADE) +
                            " " +
                            t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                        </p>
                      </div>
                      <hr className="hr-line" />

                      <div className="row mt-3">
                        <div className="col-sm col-md">
                          <Input
                            inputAttributes={{ autoFocus: "true" }}
                            className={
                              this.state.codeError
                                ? "error-code mt-2 w-25"
                                : "mt-2 w-25"
                            }
                            dataType="text"
                            label={t(CONSTANTS.LABLE_GRADE_CODE)}
                            placeholder={t(CONSTANTS.LABLE_GRADE_CODE)}
                            // required={true}
                            value={String(this.state.gradeFormData.code)}
                            onValueChange={this.setCode}
                            maxLength={10}
                            showValidationBarWhenInvalid={this.state.codeError}
                            description={
                              this.state.codeError
                                ? this.state.gradeFormData.code.length
                                  ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                  : t(CONSTANTS.FIELD_EMPTY_ERROR)
                                : ""
                            }
                          />
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-sm col-md">
                          <Input
                            dataType="text"
                            placeholder={t(CONSTANTS.LABLE_NAME)}
                            label={t(CONSTANTS.LABLE_NAME)}
                            required={true}
                            className={
                              this.state.nameError
                                ? "error-code mt-2 w-50"
                                : "mt-2 w-50"
                            }
                            value={this.state.gradeFormData.name}
                            onValueChange={this.setName}
                            maxLength={250}
                            showValidationBarWhenInvalid={this.state.nameError}
                            description={
                              this.state.nameError
                                ? this.state.gradeFormData.name.length
                                  ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                  : t(CONSTANTS.FIELD_EMPTY_ERROR)
                                : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-sm col-md">
                          <Input
                            dataType="textarea"
                            label={t(CONSTANTS.LABEL_DESCRIPTION)}
                            placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                            value={this.state.gradeFormData.description}
                            onValueChange={this.setDescription}
                            inputAttributes={{ rows: "4" }}
                            className="mt-2 h-25"
                            resizable={false}
                            maxLength={200}
                          />
                        </div>
                      </div>
                      <div className="p-3">
                        {200 - this.state.gradeFormData.description.length}{" "}
                        {t("character left out of 200 character")}
                      </div>
                    </div>
                  </div>

                  <div className="col-6 no-padding float-left">
                    <div className="box-2">
                      <div className="box-circle">
                        <p className="box-circle-text"> 2 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">
                          {t(CONSTANTS.LABLE_ADDITIONAL_INFORMATION)}
                        </p>
                      </div>
                      <hr className="hr-line" />

                      <div className="row mt-3">
                        <div className="col-sm-6 col-md-6">
                          <Dropdown
                            label={t(CONSTANTS.MODULE_TESTPLAN)}
                            allowAdd={false}
                            required={true}
                            clearable={false}
                            placeholder={t(CONSTANTS.NO_TESTPLAN_SELECTED)}
                            searchable={true}
                            value={this.state.gradeFormData.selectedTestplan}
                            onChange={this.testPlanChangeHandler}
                          >
                            {this.state.testPlanDropdownList.map(
                              (o: any, index) => (
                                <DropdownOption
                                  key={index}
                                  label={o.label}
                                  value={o.value}
                                />
                              )
                            )}
                          </Dropdown>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-sm-12 col-md-12 instruments">
                          <Dropdown
                            label={t(CONSTANTS.INSTRUMENTS)}
                            required={true}
                            multiselect={true}
                            placeholder={t(CONSTANTS.NO_INSTRUMENT_SELECTED)}
                            searchable={true}
                            value={this.state.gradeFormData.selectedInstruments}
                            onChange={(value) => this.onChangeInstrument(value)}
                          >
                            {this.state.instrumentDropdownList.map(
                              (o: any, index: number) => (
                                <DropdownOption
                                  key={index}
                                  label={o.label}
                                  value={o.value}
                                />
                              )
                            )}
                          </Dropdown>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-sm-7 col-md-7">
                          <Input
                            className="mt-2 w-100"
                            dataType="text"
                            label={t(CONSTANTS.LABEL_PROPERTIES)}
                            placeholder={t(CONSTANTS.NO_PROPERTIES_SELECTED)}
                            required={true}
                            value={
                              this.state.gradeFormData.properties.length === 0
                                ? t(CONSTANTS.NO_PROPERTIES_ASSOCIATED)
                                : this.state.gradeFormData.properties.length ===
                                  1
                                  ? t(CONSTANTS.ONE_PROPERTY_ASSOCIATED)
                                  : `${String(
                                    this.state.gradeFormData.properties.length
                                  )}` +
                                  " " +
                                  t(CONSTANTS.PROPERTIES_ASSOCIATED)
                            }
                          />
                        </div>
                        <div className="col-sm-4 col-md-4 mt-4 pt-2">
                          <Button
                            sizeClass="small"
                            type="discreet-blue"
                            disabled={
                              this.state.gradeFormData.properties.length === 0
                            }
                            className="associate-btn"
                            text={t(CONSTANTS.SHOW_HIDE_PROPERTY)}
                            onClick={this.associationAction}
                          />
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-sm-6 col-md-6">
                          <CalculatedProperty
                            selectedCalculatedProperties={this.state.selectedCalculatedProperties}
                            calculateChangeHandler={this.calculateChangeHandler}
                            allCalculatedDropdownList={this.state.allCalculatedDropdownList}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                {this._selectedTestplan ? (
                  <div className="box-below-form create_property mb-4">
                    <div className="box-circle">
                      <p className="box-circle-text"> 3 </p>
                    </div>
                    <div className="ml-4">
                      <div className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.LABEL_PROPERTIES)}
                      </div>
                    </div>
                    {this.state.selectedCalculatedProperties.length > 0 ? (
                      <hr className="hr-line mt-3" />
                    ) : null}

                    {this.state.selectedCalculatedProperties.length > 0 ? (
                      <PropertySteps isStep={this.state.isStep} />
                    ) : null}

                    {this.state.showthreshold && !this.state.showformula && (
                      <PropertyTable
                        list={this.state.gradeFormData.properties}
                        onChangeValue={this.onChangeValue}
                        onBlurValue={this.onBlurValue}
                        setPropertiesOrderNo={this.setPropertiesOrderNo}
                        isNext={this.state.isNext}
                        onNextClick={this.onNextClick}
                      />
                    )}

                    {this.state.showformula && (
                      <FormulaDefinitionTable
                        optionRef={this.optionRef}
                        onCloseAll={this.onCloseAll}
                        onToggleClick={this.onToggleClick}
                        valueList={this.state.valueList}
                        calculatedPropertyDetails={this.state.calculatedPropertyDetails}
                        readingSourceList={this.state.readingSourceList}
                        oldPartitionName={this._oldPartitionName}
                        readingValuesList={this.state.readingValuesList}
                        partitionName={this._partitionName}
                        onSourceChangeHandler={(
                          value,
                          index,
                          i,
                          calculatedId
                        ) =>
                          this.onSourceChangeHandler(
                            value,
                            index,
                            i,
                            calculatedId
                          )
                        }
                        onValuesChangeHandler={(
                          value,
                          index,
                          i,
                          calculatedId
                        ) =>
                          this.onValuesChangeHandler(
                            value,
                            index,
                            i,
                            calculatedId
                          )
                        }
                        onPartitionChangeHandler={(
                          value,
                          index,
                          i,
                          calculatedId,
                          selectedElement
                        ) =>
                          this.onPartitionChangeHandler(
                            value,
                            index,
                            i,
                            calculatedId,
                            selectedElement
                          )
                        }
                        disableValueDropdown={this.state.disableValueDropdown}
                        disablePositionDropdown={this.state.disablePositionDropdown}
                        disableSourceDropdown={this.state.disableSourceDropdown}
                        onEditPartitionChange={(
                          value,
                          index,
                          i,
                          calculatedId
                        ) =>
                          this.onEditPartitionChange(
                            value,
                            index,
                            i,
                            calculatedId
                          )
                        }
                        thresholdvalue={this.thresholdvalue}
                        showGrade={true}
                      />
                    )}
                  </div>
                ) : null}
              </div>
            </div>

            <Dialog
              isOpen={this.state.modalWarningTestplanChange}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() =>
                this.setState({ modalWarningTestplanChange: false })
              }
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.TESTPLAN_CHANGE_MSG)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.triggerTestplanChange,
                },
              ]}
            >
              <div>
                {t(CONSTANTS.EXISTING_PROPERTY_MESSAGE)}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.GRADE_LOST_MESSAGE)}
              </div>
            </Dialog>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form);
